import { useEffect } from "react";
import LogRocket from 'logrocket'

const APP_ID = process.env.REACT_APP_LOG_ROCKET
const env = process.env.REACT_APP_ENVIRONMENT

export default function useLogRocket() {


    useEffect(() => {

        function log() {
            let user = localStorage.getItem("tokens")
            if (user != null) {
                user = JSON.parse(user)

                LogRocket.init(APP_ID)
                LogRocket.identify({
                    email: user.username,
                    role: user.rol[0]
                })
            } else {
                LogRocket.init(APP_ID)
            }
        }

        if (env != "dev") {
            log()
        }
    }, [])
}